/* global window, document */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { Route, Router, browserHistory } from 'react-router';
import {
  createStore, applyMiddleware, compose, combineReducers,
} from 'redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import createSagaMiddleware from 'redux-saga';
import { routerReducer, syncHistoryWithStore, routerMiddleware } from 'react-router-redux';

import assetsLandingReducer from './components/assets-landing/__storeFiles__/reducer';
import { contractingSignUp } from './stores/contracting-sign-up/reducer';
import dummyAcct from './components/contracting/dummy-account/__store-files__/reducers';
import AssetsLandingRouter from './components/assets-landing/router';
import AssetsLanding from './components/assets-landing/container';
import RequestRouterContainer from './components/assets-landing/request/router-container';
import Request from './components/assets-landing/request/request';
import Signing from './components/assets-landing/request/signing';
import { downloadDocs } from './stores/contracting/misc-reducers';

import sagas from './sagas';
import ui from './stores/ui/ui-reducer';
import sidebarHelp from './components/sidebarHelp/reducer';

require('../less/main.less'); // FOR WEBPACK

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const createStoreWithMiddleware = composeEnhancers(applyMiddleware(thunk, sagaMiddleware, routerMiddleware(browserHistory)))(createStore);
const reducer = combineReducers({
  ui,
  sidebarHelp,
  assetsLandingReducer,
  dummyAcct,
  contractingSignUp,
  routing: routerReducer,
  contracting: combineReducers({
    downloadDocs,
  }),
});
function configureStore() {
  const st = createStoreWithMiddleware(reducer);
  if (module.hot) {
    module.hot.accept('./components/assets-landing/__storeFiles__/reducer', () => st.replaceReducer(require('./components/assets-landing/__storeFiles__/reducer')),);
  }
  sagaMiddleware.run(sagas);
  return st;
}

// Needed for onTouchTap
// Can go away when react 1.0 release
// Check this repo:
// https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin();

/* jshint ignore:start */

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);


let hidden = null;
let visibilityChange = null;
if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}
class AssetsLandingRoot extends React.Component {

  componentDidMount() {
    document.addEventListener(visibilityChange, this.handleVisibilityChange, false);
  }

  componentWillUnmount() {
    document.removeEventListener(visibilityChange, this.handleVisibilityChange);
  }
  handleVisibilityChange = () => {
    if (document[hidden]) {
      console.log(hidden, 'hidden');
    } else {
      store.dispatch({ type: 'REFRESH_DATA_IN_PAGE_BACKGROUND' });
    }
  };

  render() {
    return (
      <Provider store={store}>
        <div style={{ height: '100%' }}>
          <Router history={history}>
            <Route component={AssetsLandingRouter}>
              <Route component={AssetsLanding} path="/assets-landing"/>
              <Route component={RequestRouterContainer}>
                <Route component={Request} path="/assets-landing-request"/>
                <Route component={Signing} path="/assets-landing-signing"/>
              </Route>
            </Route>
          </Router>
        </div>
      </Provider>
    );
  }
}
ReactDOM.render(
  <AssetsLandingRoot/>,
  document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./src/app/assetsLanding.jsx